export default {
    getHeaderFields: state => state.headerFields,
    getMissingPACSHeaderFields: state => state.missingPACSHeaderFields,
    getLoginPACSHeaderFields: state => state.loginPACSHeaderFields
}
